// <test-component></test-component>; // false
// <test-component deletable></test-component>; // true
// <test-component deletable="true"></test-component>; // true
// <test-component deletable="false"></test-component>; // false
// <test-component :deletable="undefined"></test-component>; // false

export default {
  methods: {
    // ATTRIBUTE CHECK
    // <component name>
    hasAttribute(attrName) {
      const attr = this.$attrs[attrName];

      if (attr === '' || attr === true || attr === 'true') {
        return true;
      } else {
        return false;
      }
    },
    parseAttr(key, options = {}) {
      const attr = this.$attrs[key];

      if (attr === undefined) return options.default;

      if (attr === '' || attr === true || attr === 'true') {
        return true;
      } else {
        return false;
      }
    },
    // EVENT CHECK
    // <component @name>
    hasEvent(name) {
      if (this.$listeners[name]) {
        return true;
      } else {
        return false;
      }
    },
    //<component @onClick=""> or <component v-on:onClick="">
    parseVOnAttr(key, options = {}) {
      if (this.$listeners[key] === undefined) return options.default;
      if (this.$listeners[key]) return true;
      else return false;
    },
  },
};
